// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EfyF","col":"styles_col__3lQfi"};